/* @ngInject */
const genericOptions = (
  utils
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.title = 'Export SyGeM'
    options.filename = 'perso'
    options.enableColor = true
    options.firstRow = 3
    options.rowHeight = 15
    options.enableTitle = true
    options.enableHeaders = true

    return options
  }

  return self
}
export default genericOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/perso/genericOptions.resource.js